class ProductEngraving extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector('.engraving-checkbox');
    this.textWrapper = this.querySelector('.product-form__engraving-text-wrapper');
    this.textInput = this.querySelector('.product-form__engraving-text');
    this.characterCount = this.querySelector('.engraving-character-count-current');
    this.maxLength = this.textInput ? parseInt(this.textInput.getAttribute('maxlength')) || 0 : 0;

    if (this.checkbox && this.textWrapper) {
      this.checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
    }

    if (this.textInput && this.maxLength > 0 && this.characterCount) {
      this.textInput.addEventListener('input', this.handleTextInput.bind(this));
      // Initialize character count
      this.updateCharacterCount();
    }
  }

  handleCheckboxChange() {
    if (this.checkbox.checked) {
      this.textWrapper.style.display = 'block';
      this.textInput.focus();
    } else {
      this.textWrapper.style.display = 'none';
      this.textInput.value = '';
      this.updateCharacterCount();
    }
  }

  handleTextInput() {
    this.updateCharacterCount();
  }

  updateCharacterCount() {
    if (this.characterCount && this.textInput) {
      const currentLength = this.textInput.value.length;
      this.characterCount.textContent = currentLength;
      
      // Optionally add visual feedback when approaching limit
      const parent = this.characterCount.closest('.engraving-character-count');
      if (parent) {
        if (currentLength >= this.maxLength * 0.9) {
          parent.classList.add('near-limit');
        } else {
          parent.classList.remove('near-limit');
        }
      }
    }
  }
}

if (!customElements.get('product-engraving')) {
  customElements.define('product-engraving', ProductEngraving);
}

